import PropTypes from 'prop-types';
import React from 'react';

const StatusPill = ({ onTour }) => (
  <span className={`ab-pill ${onTour ? 'ab-pill--on' : 'ab-pill--off'}`}>{onTour ? 'On tour' : 'Off tour'}</span>
);
StatusPill.propTypes = { onTour: PropTypes.bool };

export default StatusPill;
